// extracted by mini-css-extract-plugin
module.exports = {"deleteShowerComp":"deleteshower_deleteShowerComp__1e--U","confirmationWrapper":"deleteshower_confirmationWrapper___F7FG","actions":"deleteshower_actions__1MZsi"};